var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoComplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3855_5596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 56.3418C48.8594 56.3418 60.5 44.7012 60.5 30.3418C60.5 15.9824 48.8594 4.3418 34.5 4.3418C20.1406 4.3418 8.5 15.9824 8.5 30.3418C8.5 44.7012 20.1406 56.3418 34.5 56.3418Z",
    fill: "url(#paint0_linear_3855_5596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6375 22.8669L31.7375 41.3919C30.6 42.692 28.65 42.692 27.5125 41.3919L20.3625 33.4294C19.3875 32.2919 19.3875 30.5044 20.5249 29.3669C21.6625 28.3919 23.4499 28.3919 24.5875 29.5294L29.625 35.2169L44.4124 19.1294C45.55 17.9919 47.3374 17.8294 48.475 18.9669C49.6124 19.9419 49.6124 21.8919 48.6375 22.8669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3855_5596",
    x: 0.5,
    y: 0.341797,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3855_5596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3855_5596",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3855_5596",
    x1: 38.5,
    y1: 56,
    x2: 35.1572,
    y2: 4.21579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA578"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComplete);
export default __webpack_public_path__ + "static/media/ico-complete.efdc2fae781cbd1a77bfb241a9995b6f.svg";
export { ForwardRef as ReactComponent };